exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hint_tooltip_controller__regular-tooltip--3dxRC {\n\twidth: 90%;\n\tposition: absolute;\n}\n\n.hint_tooltip_controller__first-lesson-tooltip--15c9N {\n\ttransform: translateY(-50%);\n\tposition: absolute;\n\ttop: 50%;\n\tleft: calc(100% + 10px);\n}\n", ""]);

// exports
exports.locals = {
	"regular-tooltip": "hint_tooltip_controller__regular-tooltip--3dxRC",
	"first-lesson-tooltip": "hint_tooltip_controller__first-lesson-tooltip--15c9N"
};